<template>
<body>      
    <div class="signup">
      <div class='pattern'></div>


        <v-layout justify-end style="margin-right:50px">
          <img src="elementos-pantalla-azulcielo-14.png" >
        </v-layout>

        <v-layout row justify-center style="margin-top:-100px">      
            <ChangePasswordButton></ChangePasswordButton>
         <br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>
        </v-layout>

        <v-layout class="pl-5" style="margin-top:-100px">
          <img src="mrosa.png">
        </v-layout>

  </div>

</body>
</template>


<script>
import ChangePasswordButton from '../components/ChangePasswordButton'

export default {
    components:{      
      ChangePasswordButton
    },

    data () {
      return {
        show2: false,
        password: 'Contraseña',
        rules: {
          required: value => !!value || 'Required.',
          min: v => v.length >= 8 || 'Min 8 characters',
          //emailMatch: () => ('The email and password you entered don\'t match')
        },
        email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ]
      }
      
    }
    
}
</script>


<style>

   /* body{
        background-color: #2F478D;
    }*/

    .signup {
  text-align: left;
  width: 100%;
  margin: auto;
  position: relative;
  z-index: 1;

}

.signup img{
    z-index: 2;
}

.theme--light.v-icon{
  color:#B4347E;
}



</style>